import businessImg from '../../../img/business.png';
import ecomImg from '../../../img/e-commerce.png';
import analyticsImg from '../../../img/analytics.png'; 

const products = [
  {
    title: 'BUSINESS MANAGEMENT PLATFORM',
    desc: 'A comprehensive SaaS solution for SMBs — CRM, task management, invoicing, and reporting in one place. Ready-to-deploy or fully customised.',
    tag: 'WEB APP',
    img: businessImg,
    color: 'bg-white',
    accent: 'text-[#FF6B35]',
  },
  {
    title: 'E-COMMERCE ENGINE',
    desc: 'A high-performance e-commerce platform with AI-powered recommendations, inventory management, and multi-currency checkout — built to scale.',
    tag: 'MOBILE + WEB',
    img: ecomImg,
    color: 'bg-[#FFD93D]',
    accent: 'text-black',
  },
  {
    title: 'ANALYTICS & MARKETING SUITE',
    desc: 'An integrated digital marketing toolkit — campaign management, audience segmentation, A/B testing, and ROI tracking — all in one dashboard.',
    tag: 'SAAS TOOL',
    img: analyticsImg,
    color: 'bg-[#1A1A1A]',
    accent: 'text-[#FFD93D]',
  },
];

export default function MarketSection() {
  return (
    <section id="products" className="bg-[#FF6B35] py-24 md:py-36 px-8 md:px-16 overflow-hidden">
      <div className="w-full">
        {/* Header */}
        <div className="text-center mb-20">
          <span
            className="text-white/20 font-black leading-none block"
            style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(80px, 12vw, 160px)' }}
          >
            04
          </span>
          <h2
            className="text-white font-black uppercase leading-none -mt-8 md:-mt-16"
            style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(40px, 8vw, 120px)' }}
          >
            OUR
            <br />
            PRODUCTS
          </h2>
          <p className="text-white/80 font-bold text-xl md:text-2xl uppercase tracking-widest mt-6">
            Digital solutions engineered to move fast and scale further.
          </p>
        </div>

        {/* Product cards */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-20">
          {products.map((p) => (
            <div key={p.title} className={`${p.color} rounded-[30px] overflow-hidden flex flex-col`}>
              <div className="w-full h-52 overflow-hidden">
                <img src={p.img} alt={p.title} className="w-full h-full object-cover object-top" />
              </div>
              <div className="p-8 flex-1 flex flex-col">
                <div className="inline-block mb-4">
                  <span
                    className={`${p.accent} font-black uppercase text-sm tracking-widest border-2 ${p.color === 'bg-[#1A1A1A]' ? 'border-white/20 text-white/60' : 'border-black/20'} px-4 py-1 rounded-full`}
                    style={{ fontFamily: "'Bebas Neue', sans-serif" }}
                  >
                    {p.tag}
                  </span>
                </div>
                <h3
                  className={`font-black uppercase leading-tight mb-4 ${p.color === 'bg-[#1A1A1A]' ? 'text-white' : 'text-black'}`}
                  style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(22px, 2.5vw, 30px)' }}
                >
                  {p.title}
                </h3>
                <p className={`font-semibold text-base leading-relaxed ${p.color === 'bg-[#1A1A1A]' ? 'text-white/60' : 'text-black/60'}`}>
                  {p.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Big stat row */}
        <div className="border-t-4 border-white/30 pt-16 grid grid-cols-2 lg:grid-cols-4 gap-8 text-center">
          {[
            { val: '120+', label: 'PROJECTS DONE' },
            { val: '10+', label: 'YEARS IN MARKET' },
            { val: '99%', label: 'CLIENT RETENTION' },
            { val: '0', label: 'MISSED DEADLINES' },
          ].map((s) => (
            <div key={s.val}>
              <div
                className="text-white font-black leading-none"
                style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(48px, 6vw, 80px)' }}
              >
                {s.val}
              </div>
              <div
                className="text-white/70 font-black uppercase tracking-widest text-lg mt-2"
                style={{ fontFamily: "'Bebas Neue', sans-serif" }}
              >
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
